import { isRestaurantOnly } from '../config/restaurantOnly'

export const TabId = {
  Orders: 'orders',
  Chat: 'chat',
  Search: 'search',
  Cart: 'cart',
  Prices: 'prices',
  Analytics: 'analytics',
} as const

export type TabId = (typeof TabId)[keyof typeof TabId]

export type TabConfig = {
  id: TabId
  label: string
}

export const LEGACY_TABS: TabConfig[] = [
  { id: TabId.Orders, label: 'Заявки' },
  { id: TabId.Chat, label: 'Чаты' },
]

export const RESTAURANT_TABS: TabConfig[] = [
  { id: TabId.Search, label: 'Поиск' },
  { id: TabId.Cart, label: 'Корзина' },
  { id: TabId.Prices, label: 'Прайсы' },
  { id: TabId.Analytics, label: 'Аналитика' },
]

export const MAIN_TABS: TabConfig[] = isRestaurantOnly ? RESTAURANT_TABS : LEGACY_TABS

export const DEFAULT_TAB: TabId = isRestaurantOnly ? TabId.Search : TabId.Orders
